module.exports = __webpack_public_path__ + "static/media/portfolio14.a61425a0.jpeg";